import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';

import { routes } from 'router/routes';
import { RootLayout } from 'router/layouts';

import { DatadogRUM } from '@user-portal/datadog-rum';

import RootBoundary from './RootBoundary';
import ProtectedRoute from './ProtectedRoute';

const createBrowserRouter = DatadogRUM.getReactRouter();

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />} errorElement={<RootBoundary />}>
            {routes.map((route) => {
                const {
                    path,
                    layout: Layout,
                    component: Component,
                    titleKey,
                    withCenteredContent,
                    validators,
                    redirectPath,
                } = route;

                return (
                    <Route
                        key={path}
                        path={path}
                        element={
                            <ProtectedRoute validators={validators} redirectPath={redirectPath}>
                                <Layout titleKey={titleKey} withCenteredContent={withCenteredContent}>
                                    <Component />
                                </Layout>
                            </ProtectedRoute>
                        }
                    />
                );
            })}
        </Route>
    )
);

export default router;
